import { createContext } from "react";

import type { TenantThemeRuntime } from "../core/types.ts";

export const TenantThemeRuntimeContext =
  createContext<TenantThemeRuntime | null>(null);
